import { User } from './types/User';

const userValues = (values: { data: { data: { user: User } } }) => {
  return values?.data?.data?.user;
};
export default userValues;
